<template>
  <div class="basic-page">
    <div class="desc-logo">
      <a href="/">
        <img :alt="logoAlt" :src="websiteLogo" />
      </a>
      <h1>{{ websiteTitle }}</h1>
    </div>
    <div class="content"></div>
  </div>
</template>
<script>
export default {
  name: "BasicPage",

  mounted() {
    let highlighted = document.querySelector(".region-highlighted");
    let content = document.querySelector(".region-content");
    this.$el.querySelector(".content").append(highlighted);
    this.$el.querySelector(".content").append(content);
  },

  data() {
    return {
      websiteTitle: window.drupalSettings.website.title,
      websiteLogo: window.drupalSettings.website.logo,
      logoAlt: window.drupalSettings.website.logo + " logo",
    };
  },

  methods: {},
};
</script>
<style lang="scss">
.basic-page {
  max-width: 1440px;
  margin-left: 10%;
  margin-right: 10%;
  .page-title,
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    color: $grey-dark;
  }
  .page-title,
  h1,
  h2,
  h3,
  h4,
  h5 {
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
